import {
  Checkbox as HeadlessCheckbox,
  CheckboxProps as HeadlessCheckboxProps,
} from "@headlessui/react"
import { Check } from "lucide-react"

import { classNames } from "../../../../lib/classNames"
import { Icon, IconSizes } from "../../../Icon"

export interface CheckboxProps
  extends Omit<HeadlessCheckboxProps, "className" | "checked"> {
  checked: boolean
  className?: string
}

export function Checkbox({
  className,
  onChange,
  ...otherProps
}: CheckboxProps) {
  const disablePointerEvents =
    onChange === undefined && otherProps?.onClick === undefined
  return (
    <HeadlessCheckbox
      className={classNames(
        "rounded-xs border-bolder hover:border-boldest group box-border inline-flex size-4 cursor-pointer items-center justify-center border-2 bg-transparent align-middle",
        "data-disabled:border-v2-border-strong data-disabled:bg-input-disabled data-disabled:cursor-not-allowed",
        "data-checked:bg-primary-default data-checked:hover:bg-primary-hovered data-checked:data-disabled:bg-primary-disabled data-checked:border-none",
        disablePointerEvents && "pointer-events-none",
        className
      )}
      onChange={onChange}
      {...otherProps}
    >
      <Icon
        icon={Check}
        size={IconSizes.ExtraSmall}
        className="color-icon-inverse group-data-checked:opacity-100 opacity-0"
      />
    </HeadlessCheckbox>
  )
}
